import React from "react";
import {Icon, IconSize, IWizardStep} from "@renta-apps/athenaeum-react-components";
import {BaseComponent} from "@renta-apps/athenaeum-react-common";

import styles from "./FormNavigation.module.scss";
import Localizer from "@/localization/Localizer";

interface IFormNavigationProps {
    steps: IWizardStep[];
    currentIndex: number;

    onNavigate?(step: IWizardStep): Promise<void>;

    onClick?(): Promise<void>;
}

interface IFormNavigationState {
    edit: boolean;
    value: string
}

export default class FormNavigation extends BaseComponent<IFormNavigationProps, IFormNavigationState> {

    state: IFormNavigationState = {
        edit: false,
        value: ""
    };

    private readonly _ref: React.RefObject<HTMLInputElement> = React.createRef();

    private get steps(): IWizardStep[] {
        return this.props.steps;
    }

    private get currentIndex(): number {
        return this.props.currentIndex;
    }

    private get stepIndexVisible(): boolean {
        return (this.currentIndex >= 0) && (this.currentIndex < this.steps.length - 1);
    }

    private get currentStep(): IWizardStep {
        return this.steps[this.currentIndex];
    }

    private async onEditIndexAsync(value: string): Promise<void> {
        if ((value.length === 0) || ((value.length <= 2) && (/^\d+$/.test(value)))) {
            if (this.state.value !== value) {
                await this.setState({value});
            }
        }
    }

    private async onEditKeyUpAsync(keyCode: number): Promise<void> {
        if (keyCode === 27) {
            await this.setState({edit: false});
        } else if (keyCode === 13) {

            let index: number = (parseInt(this.state.value));

            await this.setState({value: "", edit: false});

            if (!isNaN(index)) {
                index -= 1;
                if ((index >= 0) && (index <= this.steps.length - 1) && (index !== this.currentIndex) && (this.props.onNavigate)) {
                    const step: IWizardStep = this.steps[index];
                    await this.props.onNavigate(step);
                }
            }
        }
    }

    private async onEditBlurAsync(): Promise<void> {
        await this.setState({edit: false});
    }

    private async onClickHandlerAsync(): Promise<void> {
        if ((!this.state.edit) && (this.props.onClick)) {
            await this.props.onClick();
        }
    }

    render(): React.ReactNode {
        return (
            <div className={this.css(styles.formNavigation)}>
                <div onClick={async () => await this.onClickHandlerAsync()}>

                    <span className={styles.step}>{Localizer.formNavigationStep}</span>
                    {
                        (this.stepIndexVisible) &&
                        (
                            <span className={styles.index}>
                                {
                                    (this.state.edit) &&
                                    (<input ref={this._ref} size={1} maxLength={2}
                                            value={this.state.value}
                                            onChange={async (e: React.FormEvent<HTMLInputElement>) => await this.onEditIndexAsync(e.currentTarget.value)}
                                            onKeyUp={async (e: React.KeyboardEvent<HTMLInputElement>) => await this.onEditKeyUpAsync(e.keyCode)}
                                            onBlur={async () => this.onEditBlurAsync()}
                                        />
                                    )
                                }
                                {
                                    (!this.state.edit) &&
                                    (
                                        <span>{this.currentIndex + 1}</span>
                                    )
                                }

                                &nbsp;/ {this.steps.length - 1}

                            </span>
                        )
                    }

                    {(!this.stepIndexVisible) && (this.currentStep.icon) && (
                        <Icon {...this.currentStep.icon}
                              className={styles.icon}
                              size={IconSize.X2}
                        />
                    )}

                    <div className={styles.title}>
                        {(this.currentStep.icon) && (this.stepIndexVisible) && (
                            <Icon {...this.currentStep.icon}
                            />)}
                        <span>{this.currentStep.title}</span>
                    </div>

                </div>
            </div>
        );
    }
};